import type { HTMLAttributes } from 'react';

import { cn } from '@/shared/lib/cn';

export interface GlassNavProps extends HTMLAttributes<HTMLElement> {
  as?: 'nav' | 'header' | 'footer' | 'div';
  testID?: string;
}

export function GlassNav({ as: Tag = 'nav', className, testID, style, ...props }: GlassNavProps) {
  return (
    <Tag
      data-testid={testID}
      style={{
        background: 'var(--glass-bg)',
        backdropFilter: 'var(--glass-blur)',
        WebkitBackdropFilter: 'var(--glass-blur)',
        ...style,
      }}
      className={cn('w-full text-on-surface', className)}
      {...props}
    />
  );
}
